<div mat-dialog-content>
  <p>{{ message }}</p>
</div>

<div mat-dialog-actions style="width: 100%; text-align: center">
  <button mat-button (click)="onDismiss()">Ne</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Da</button>
</div>
